import EmblaCarousel from "embla-carousel"
import { addPrevNextBtnsClickHandlers } from "./embla/arrows"
import { addDotBtnsAndClickHandlers } from "./embla/dots"

export default class VideoGallery {
  constructor() {
    this.emblaNode = document.querySelectorAll(".video-gallery .embla")
    this.$body = $("body")
    const self = this

    if (!this.emblaNode.length) return

    this.emblaNode.forEach((node) => this.initCarousel(node))

    if ($(".video-gallery").length > 0) {
      $(".video-card").each((index, video) => {
        const $video = $(video)
        $video.on("click", () => {
          // data-modal holds the video id (e.g. 12345). Modal element id is `video-modal-{id}`
          const modalAttr =
            $video.data("modal") ||
            $video.attr("data-modal") ||
            $video.attr("modal")
          if (!modalAttr) return

          const selector = `#video-modal-${modalAttr}`
          const $modal = $(selector)
          if (!$modal.length) return

          $modal.fadeIn(300, () => {
            // Accessibility: mark modal attributes and hide background content
            const titleText =
              $video.find(".video-card__title").text() || "Video dialog"
            $modal.attr({
              role: "dialog",
              "aria-modal": "true",
              "aria-label": titleText,
            })
            // hide everything else from assistive tech
            this.$body.children().not($modal).attr("aria-hidden", "true")

            this.$body.addClass("no-scroll")

            // save focus and move focus to the modal close button
            this._lastFocused = document.activeElement
            this._openModal = $modal
            const $close = $modal.find(".video-card--modal__close")
            if ($close.length) {
              $close.attr("tabindex", 0).focus()
            } else {
              $modal.attr("tabindex", -1).focus()
            }

            // focus trap: keep Tab within modal
            $(document).on("keydown.modalFocus", (e) => {
              if (!this._openModal) return
              if (e.key === "Tab" || e.keyCode === 9) {
                const focusable = this._openModal
                  .find(
                    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]',
                  )
                  .filter(":visible")
                if (!focusable.length) {
                  e.preventDefault()
                  return
                }
                const first = focusable.first()[0]
                const last = focusable.last()[0]
                if (e.shiftKey) {
                  if (document.activeElement === first) {
                    e.preventDefault()
                    last.focus()
                  }
                } else {
                  if (document.activeElement === last) {
                    e.preventDefault()
                    first.focus()
                  }
                }
              }
            })
            // try to autoplay iframe (YouTube/Vimeo) by flipping autoplay=0 -> autoplay=1
            const $iframe = $modal.find("iframe")
            if ($iframe.length) {
              const src = $iframe.attr("src") || ""
              if (src.includes("autoplay=0")) {
                $iframe.attr("src", src.replace("autoplay=0", "autoplay=1"))
              } else if (!src.includes("autoplay=1") && src.length) {
                const sep = src.includes("?") ? "&" : "?"
                $iframe.attr("src", src + sep + "autoplay=1")
              }
            }

            // try to play a native <video> element if present
            const $videoEl = $modal.find("video")
            if ($videoEl.length && $videoEl[0].play) {
              try {
                $videoEl[0].play()
              } catch (e) {
                // autoplay might be blocked; ignore errors
              }
            }
          })
        })
      })

      $(".video-card__close").on("click", (event) => {
        const $parent = $(event.currentTarget).parent()
        $parent.fadeOut(300)
        this.$body.removeClass("no-scroll")

        const $iframe = $parent.find("iframe")
        const $video = $parent.find("video")

        if ($iframe.length > 0) {
          $iframe.attr(
            "src",
            $iframe.attr("src").replace("autoplay=1", "autoplay=0"),
          )
        }

        if ($video.length > 0) {
          $video[0].pause()
        }
      })

      // Close all modals when clicking the modal inner container or the modal close button
      $(document).on(
        "click",
        ".video-card--modal, .video-card--modal__close",
        () => {
          this.closeModals()
        },
      )

      // Close on Escape key
      $(document).on("keydown", (e) => {
        if (e.key === "Escape" || e.keyCode === 27) {
          this.closeModals()
        }
      })

      // Prevent clicks inside the video area from bubbling up and closing the modal
      $(document).on("click", ".video-card--modal__video", (e) => {
        e.stopPropagation()
      })
    }
  }

  closeModals() {
    const $modals = $(".video-card--modal")
    $modals.fadeOut(300)
    this.$body.removeClass("no-scroll")
    // restore aria-hidden on background
    this.$body.children().attr("aria-hidden", null)

    // remove dialog attributes and open modal reference
    if (this._openModal) {
      this._openModal.removeAttr("role aria-modal aria-label tabindex")
      this._openModal = null
    }

    // unbind focus trap
    $(document).off("keydown.modalFocus")

    // restore focus
    if (this._lastFocused && this._lastFocused.focus) {
      try {
        this._lastFocused.focus()
      } catch (e) {
        // ignore
      }
    }
    $modals.each((i, modal) => {
      const $m = $(modal)
      const $iframe = $m.find("iframe")
      const $video = $m.find("video")

      if ($iframe.length > 0) {
        $iframe.attr(
          "src",
          $iframe.attr("src").replace("autoplay=1", "autoplay=0"),
        )
      }

      if ($video.length > 0) {
        try {
          $video[0].pause()
        } catch (e) {
          // ignore
        }
      }
    })
  }

  initCarousel(node) {
    const viewportNode = node.querySelector(".embla__viewport")

    const leftEdge = node.querySelector(".embla__edge--start")
    const rightEdge = node.querySelector(".embla__edge--end")

    const prevBtnNode = node.querySelector(".embla__button--prev")
    const nextBtnNode = node.querySelector(".embla__button--next")
    const dotsNode = node.querySelector(".embla__dots")

    if (node && viewportNode) {
      const emblaApi = EmblaCarousel(viewportNode, {
        align: "center",
        dragThreshold: 5,
        breakpoints: {
          "(min-width: 768px)": { active: false },
        },
      })

      emblaApi.on("init", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
        this.updateActiveSlide(node, emblaApi)
      })

      // update active class when selection changes
      emblaApi.on("select", () => this.updateActiveSlide(node, emblaApi))

      emblaApi.on("resize", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      emblaApi.on("scroll", () => {
        this.toggleEdges(leftEdge, rightEdge, emblaApi)
      })

      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        emblaApi,
        prevBtnNode,
        nextBtnNode,
      )
      const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
        emblaApi,
        dotsNode,
      )

      emblaApi.on("destroy", removeDotBtnsAndClickHandlers)
      emblaApi.on("destroy", removePrevNextBtnsClickHandlers)
    }
  }

  toggleEdges(start, end, emblaApi) {
    const progress = Math.round(emblaApi.scrollProgress() * 100)

    if (progress <= 0) {
      start.classList.remove("is-visible")
    } else {
      start.classList.add("is-visible")
    }

    if (progress === 100) {
      end.classList.remove("is-visible")
    } else {
      end.classList.add("is-visible")
    }
  }

  updateActiveSlide(node, emblaApi) {
    const slideNodes = node.querySelectorAll(".embla__slide")
    if (!slideNodes || !slideNodes.length) return

    // clear any existing active class
    slideNodes.forEach((s) => s.classList.remove("is-active"))

    try {
      const selected = emblaApi.selectedScrollSnap()
      const activeSlide = slideNodes[selected]
      if (activeSlide) activeSlide.classList.add("is-active")
    } catch (err) {
      // fallback: use selectedIndex if different API available
      const index =
        emblaApi.selectedIndex && typeof emblaApi.selectedIndex === "number"
          ? emblaApi.selectedIndex
          : null
      if (index !== null && slideNodes[index])
        slideNodes[index].classList.add("is-active")
    }
  }
}
